import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPortalFilledFacebookIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M9.1693 0.0600586C11.5693 0.0600586 13.6093 0.900059 15.2893 2.58006C16.9693 4.26006 17.8093 6.29406 17.8093 8.68206C17.8093 11.0701 16.9693 13.1101 15.2893 14.8021C13.6093 16.4941 11.5693 17.3401 9.1693 17.3401C6.7693 17.3401 4.7293 16.4941 3.0493 14.8021C1.3693 13.1101 0.529297 11.0701 0.529297 8.68206C0.529297 6.29406 1.3693 4.26006 3.0493 2.58006C4.7293 0.900059 6.7693 0.0600586 9.1693 0.0600586ZM11.2213 6.00006V4.59606H9.9253C9.3973 4.59606 8.9533 4.79406 8.5933 5.19006C8.2333 5.58606 8.0533 6.07206 8.0533 6.64806V7.44006H6.6853V8.77206H8.0533V12.7681H9.6013V8.77206H11.2213V7.44006H9.6013V6.50406C9.6013 6.16806 9.7093 6.00006 9.9253 6.00006H11.2213Z",
		fill: "#4B7987"
	})]
});
const ForwardRef = forwardRef(SvgPortalFilledFacebookIcon);
const Memo = memo(ForwardRef);
export default Memo;
